"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.div `
    margin-left:   auto;
    margin-right:  auto;
    padding-left:  24px;
    padding-right: 24px;
    width:         100%;
`;
exports.Content = (props) => react_1.default.createElement(Wrapper, null, props.children);
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sYXlvdXQvQ29udGVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBRXdDO0FBQ3hDLDBFQUFvRDtBQUVwRCxNQUFNLE9BQU8sR0FBRywyQkFBTSxDQUFDLEdBQUcsQ0FBQTs7Ozs7O0NBTXpCLENBQUM7QUFFVyxRQUFBLE9BQU8sR0FBc0IsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUNoRCw4QkFBQyxPQUFPLFFBQ0YsS0FBSyxDQUFDLFFBQVEsQ0FDVixDQUFDO0FBQ2YsQ0FBQyJ9